import * as React from 'react';
export var Context = React.createContext(null);
Context.displayName = 'ApiHooks.Context';
